import { inject } from '@angular/core';

import { LAZY_SERVICE_TOKEN } from '@ta/notification';
import { TaTranslationService } from '@ta/translation';
import { TA_USER_SERVICE } from '@ta/user';
import { TaAbstractComponent } from '@ta/utils';

import { UserService } from 'src/app/services/user/user.service';

export abstract class AbstractComponent extends TaAbstractComponent {
  // Double cast required: TA_USER_SERVICE token is typed as TaUserService (parent class).
  protected _userService = inject(TA_USER_SERVICE) as unknown as UserService;

  protected _notificationService = inject(LAZY_SERVICE_TOKEN);

  protected _appTranslationService = inject(TaTranslationService);

  public userProfile$ = this._userService.userProfile.get$();
  public userProfile = this._userService.userProfile.get();
}
